<template>
    <div>
        <p class="question-counter">
            <span class="counted">{{count}}</span> of <span class="total">{{total}}</span> questions</p>

        <div class="progress">
            <div class="progress-bar" role="progressbar" :style="'width: '+progressBar+'%'" :aria-valuenow="progressBar" aria-valuemin="0" aria-valuemax="100"></div>
        </div>

    </div>
</template>

<script>
    export default {
        props:{
            total:{
                default:1
            },
            count:{
                default: 0
            }
        },
        computed:{
            progressBar(){
                return this.count * 100 / this.total;
            },
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/common/InteresProgressBar.vue